import BillReportsContainer from "./BillReportsContainer";

export default BillReportsContainer;
